<template>
  <div>
    <div class="grid cross-center ver-padding-40">
      <h1 class="r-margin-30">IP адреса ({{ totalWhitelist }})</h1>
      <div class="u-16 u-ls grid cross-center between">
        <div class="u-16 u-5-ss u-6-ms ver-padding-10 ver-padding-0-ls">
          <AppInput v-model="search" size="small" placeholder="Найти по названию"></AppInput>
        </div>
        <div>
          <AppButton type="white" size="mini" @click="loadWhitelist">Обновить</AppButton>
          <AppButton size="mini" @click="addWhitelist">Добавить IP</AppButton>
        </div>
      </div>
    </div>

    <div class="page-block ver-margin-15 grid table-settings">
      <AppCheckbox
          class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
          v-model="columns.id"
          id="option-active"
      >ID</AppCheckbox>
      <AppCheckbox
          class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
          v-model="columns.address"
          id="option-confirm"
      >IP</AppCheckbox>
      <AppCheckbox
          class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
          v-model="columns.description"
          id="option-admin"
      >Описание</AppCheckbox>
    </div>

    <div v-loading="loading">
      <VuePerfectScrollbar class="scroll-area" :settings="scrollsettings">
        <el-table
            :data="
          whitelist.filter(
            data =>
              !search ||
              data.id.toString().includes(search.toLowerCase()) ||
              data.address.toLowerCase().includes(search.toLowerCase()) ||
              data.description.toLowerCase().includes(search.toLowerCase())
          )
        "
            :default-sort="{ prop: 'id', order: 'ascending' }"
            style="width: 100%"
            class="whitelist-table"
            size="medium"
            @row-click="rowClick"
            ref="whiteliststable"
        >
          <el-table-column prop="id" sortable label="ID" width="150">
            <template slot-scope="scope">
              {{
                scope.row.id
              }}
            </template>
          </el-table-column>
          <el-table-column prop="address" sortable label="IP" min-width="200">

          </el-table-column>
          <el-table-column
              prop="description"
              sortable
              label="Описание"
              min-width="150"
          ></el-table-column>
          <el-table-column min-width="50">
            <template slot-scope="scope">
              <div class="u-16 ver-margin-5 grid">
                <AppButton
                    class="r-margin-20"
                    size="small"
                    @click="handleDelete(scope.row.id, scope.row)"
                >Удалить</AppButton>
              </div>
            </template>
          </el-table-column>
          <div slot="empty">
            <div>{{ errorMessage }}</div>
          </div>
        </el-table>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
import errors from "@/localize/errors.js";
Vue.use(VueAxios, axios);

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "Whitelist",
  data() {
    return {
      loading: false,
      search: "",
      totalWhitelist: 0,
      whitelist: [],
      errorMessage: "Нет данных",
      columns: {
        id: true,
        address: true,
        description: true
      },
      scrollsettings: {
        suppressScrollY: true,
        swipeEasing: true
      }
    }
  },
  methods: {
    loadWhitelist() {
      this.errorMessage = "Загрузка...";
      this.loading = true;
      this.whitelist = [];
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl+"whitelist/list", config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.whitelist = data.list;
            this.totalWhitelist = data.total || this.whitelist.length;
            this.errorMessage = this.whitelist.length == 0 ? "Нет данных" : "";
            this.loading = false;
          }
        })
        .then(() => {
          this.search = this.$route.params.filter || "";
          if (this.whitelist.length > 0) {
            this.$refs.whiteliststable.toggleRowExpansion(
                this.whitelist.find(el => el.id == this.$route.params.id),
                true
            );
          }
        })
        .catch(({ response }) => {
          if (response.status != 200) this.loading = false;
          this.errorMessage =
              "(" + response.status + ") Невозможно загрузить список IP адресов";
        });
    },
    addWhitelist() {
      this.$router.push("create_whitelist");
    },
    handleDelete(index, row) {
      let req = {whitelist_id: index};
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };

      axios
      .post(
          apiUrl + "whitelist/delete",
          req,
          config
      )
      .then(({ data }) => {
        if (data.state_id == 0) {
          this.showError("IP адрес успешно удалён", "success");
          this.loadWhitelist();
        } else {
          if (errors.message.hasOwnProperty(data.message))
            this.showError(errors.message[data.message]);
          else this.showError(errors.message["default"]);
          return false;
        }
      })
      .catch(err => {
        console.log(errors);
        if (err.response) this.showError(err.response.data.message);
      });
    },
    showError(text, type) {
      type = type ? type : "error";
      this.$message({
        showClose: true,
        message: text,
        type: type,
        duration: 3000
      });
    },
    hideScroll() {
      document.documentElement.style.overflow = "hidden";
    },
    showScroll() {
      document.documentElement.style.overflow = "auto";
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    rowClick(row) {
      this.$refs.whiteliststable.toggleRowExpansion(row);
    },
  },
  created() {
    this.loadWhitelist();
  },
  components: {
    VuePerfectScrollbar
  }
}
</script>

<style lang="sass">
.el-popup-parent--hidden
  padding-right: 0px !important
.user-table
  .el-table__header
    th
      font-size: 14px
      color: #000
      padding: 10px 0px
      border-width: 1px 0 1px
      border-color: #F3F3F3
      font-weight: 300 !important
      &.is-sortable:hover,
      &.is-current-sort
        border-bottom-color: #F3F3F3
        border-top-color: #F3F3F3
  tr
    cursor: pointer
    &.el-table__row.expanded + tr
      cursor: default
      .el-table__expanded-cell
        border-left: 0px solid #e4e7ed
        padding: 0px
        .togglerow
          background: rgba(228,231,237,.3)
          width: 50px
          position: relative
          top: 0px
          bottom: 0px
          cursor: pointer
          transition: background .2s ease-out
          &:hover
            background: rgba(228,231,237,.5)
  tr td
    vertical-align: top
    .access-name
      min-width: 120px
    .el-tag
      margin: 0px 5px 0px 0
    .full-name
      font-size: .9rem
    .el-icon-star-on
      color: orange
  .el-table__expanded-cell
    .el-tag
      margin: 0px 5px 5px 0
</style>